<template>
  <app-carousel :item-gap="1" :item-width="250" :items="list">
    <template #item="{ item }">
      <div class="p-2">
        <blog-post-card :post="item" :title-level="postCardTitleLevel" />
      </div>
    </template>
  </app-carousel>
</template>

<script lang="ts" setup>
import type { BlogPostPage } from "~~/model/blog.model";

defineProps<{
  list: BlogPostPage[];
  postCardTitleLevel?: `h${2 | 3 | 4 | 5 | 6}` | "p";
}>();
</script>
